export const ArrowLeftIcon = () => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 8.99976C20 9.40801 19.7077 9.74204 19.2995 9.74204H2.42033L8.71585 16.6685C8.99133 16.9715 8.96883 17.4414 8.66584 17.7165C8.52239 17.8422 8.34146 17.9072 8.16517 17.9072C7.96363 17.9072 7.7621 17.826 7.61587 17.6636L0.193006 9.49848C-0.0643354 9.21576 -0.0643354 8.78357 0.193006 8.50103L7.61587 0.335879C7.89279 0.0314486 8.36234 0.0111284 8.66482 0.285125C8.96781 0.560606 8.99031 1.0302 8.71483 1.33314L2.42033 8.25747H19.2995C19.7077 8.25747 20 8.5915 20 8.99976Z"
        fill="#525B7A"
      />
    </svg>
  );
};
